import { create } from "zustand";

export const useAgentStore = create((set, get) => ({
  selectedAgent: null,
  agents: [],

  setSelectedAgent: (agent) =>
    set((state) => ({
      selectedAgent:
        typeof agent === "function"
          ? agent(state.selectedAgent) // ✅ call function with previous state
          : agent,                     // ✅ normal value
    })),

  setAgents: (agents) => set({ agents }),

  clearSelectedAgent: () => set({ selectedAgent: null }),

  getSelectedAgentProperties: () => {
    const { selectedAgent, agents } = get();
    if (!selectedAgent) return [];

    const agent = agents.find((a) => a.id === selectedAgent.id);
    return agent?.properties || [];
  },
}));
